import {Repository, createRepository} from '@/repositories/Base/Repository'

class ExamResultRepository extends Repository {
    endpoint = 'tuevs/exams_result'

    // Unique = {
    //     name: 'NOME',
    //     code: 'Código',
    //     status: true,
    //     id: 'ASSERERE'
    // }
    // examResults = {
    //     data: [this.Unique, this.Unique, this.Unique, this.Unique, this.Unique]
    // }
    // examResult = {
    //     data: this.Unique
    // }
    //
    // fetchAll(params) {
    //     return new Promise((resolve, reject) => {
    //         if (this.examResults.length === 0) {
    //             return setTimeout(() => reject(new Error('Results not found')), 1500);
    //         }
    //
    //         setTimeout(() => resolve(this.examResults), 1500);
    //     });
    // }
    //
    // fetch(params) {
    //     return new Promise((resolve, reject) => {
    //         setTimeout(() => resolve(this.examResult), 1500);
    //     });
    // }
}

export default new ExamResultRepository()

export const create = createRepository(ExamResultRepository)
